<template>
  <div class="card-container">
    <common-top-form
      :model="formModel"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      @openAddDialog="openAddDialog"
      :show="true"
      addShowPower="/threeapppointsnewodetojoymanage/add"
      selectShowPower="/threeapppointsnewodetojoymanage/select"
    >
      <el-form-item
        label="机构名称"
        prop="activityName"
        v-if="this.textTatSimpleId"
      >
        <el-select
          style="width: 198px"
          v-model="formModel.tatSimpleId"
          filterable
        >
          <el-option
            v-for="item in typeTwo"
            :key="item"
            :label="item.tatName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
      <el-table-column
        prop="tatSimpleName"
        label="机构名称"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="acqActiveMoney"
        label="押金金额"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="name"
        label="名称"
        min-width="220"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="tatMoney"
        label="机构奖励"
        min-width="220"
        :formatter="formatterTableNumberYuan"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="agentMoney1"
        label="代理奖励1"
        min-width="220"
        :formatter="formatterTableNumberYuan"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="agentMoney2"
        label="代理奖励2"
        min-width="220"
        :formatter="formatterTableNumberYuan"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="agentMoney3"
        label="代理奖励3"
        min-width="220"
        :formatter="formatterTableNumberYuan"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="acqActiveCode"
        label="上游活动编号"
        min-width="220"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <!-- <el-table-column
              prop="planName"
              label="商户计划名称"
              min-width="220"
              :formatter="formatterTableData"
              show-overflow-tooltip
            ></el-table-column> -->
      <el-table-column
        prop="number"
        label="期数"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="dayNumber"
        label="每期天数"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="qualifiedTransactions"
        label="达标交易量(元)"
        min-width="120"
        :formatter="formatterTableNumberYuan"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="reward"
        label="每期奖励金(元)"
        min-width="120"
        :formatter="formatterTableNumberYuan"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="couponGroupName"
        label="优惠券"
        min-width="220"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        min-width="100"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.status"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-value="1"
            inactive-value="0"
            @change="statusturns($event, scope.row)"
          />
        </template>
      </el-table-column>
      <el-table-column
        v-if="hasPerm('/threeapppointsnewodetojoymanage/update')"
        label="操作"
        min-width="100"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            v-if="hasPerm('/threeapppointsnewodetojoymanage/update')"
            @click="openAddDialog(scope.row)"
            >修改
          </el-button>
        </template>
      </el-table-column>
    </common-table>
    <form-dialog
      ref="formDialog"
      :formDialogTitle="itemId ? '修改' : '添加'"
      :model="dialogModel"
      :submitData="dialogData"
      :rules="dialogRules"
      :dialogService="dialogService"
      @close="dialogClose"
      @success="dialogSuccess"
      class="note"
      labelWidth="120px"
      dialogWidth="460px"
    >
      <el-form-item label-width="135px" label="名称" prop="name">
        <el-input
          type="text"
          maxlength="100"
          v-model="dialogModel.name"
          placeholder="请输入"
          style="width: 250px"
        ></el-input>
      </el-form-item>
      <!-- 新增 -->
      <el-form-item
        label="上游活动编号"
        prop="acqActiveMoney"
        label-width="135px"
      >
        <el-select style="width: 250px" v-model="dialogModel.acqActiveMoney">
          <el-option
            v-for="item in typeThreeList"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictValue"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label-width="135px" label="商户计划名称" prop="planName">
              <el-input
                type="text"
                maxlength="100"
                v-model="dialogModel.planName"
                placeholder="请输入"
                style="width: 250px"
              ></el-input>
            </el-form-item> -->
      <el-form-item label="机构" prop="tatSimpleId" label-width="135px">
        <el-select
          style="width: 250px"
          v-model="dialogModel.tatSimpleId"
          filterable
        >
          <el-option
            v-for="item in typeAdd"
            :key="item"
            :label="item.tatName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label-width="135px" label="机构奖励" prop="tatMoney">
        <el-input-number
          v-model="dialogModel.tatMoney"
          :min="0"
          :max="999999999"
          :step="0.1"
          :precision="2"
          :controls="false"
          placeholder="请输入"
          style="width: 250px"
        ></el-input-number>
      </el-form-item>
      <el-form-item label-width="135px" label="代理奖励1" prop="agentMoney1">
        <el-input-number
          v-model="dialogModel.agentMoney1"
          :min="0"
          :max="999999999"
          :step="0.1"
          :precision="2"
          :controls="false"
          placeholder="请输入"
          style="width: 250px"
        ></el-input-number>
      </el-form-item>
      <el-form-item label-width="135px" label="代理奖励2" prop="agentMoney2">
        <el-input-number
          v-model="dialogModel.agentMoney2"
          :min="0"
          :max="999999999"
          :step="0.1"
          :precision="2"
          :controls="false"
          placeholder="请输入"
          style="width: 250px"
        ></el-input-number>
      </el-form-item>
      <el-form-item label-width="135px" label="代理奖励3" prop="agentMoney3">
        <el-input-number
          v-model="dialogModel.agentMoney3"
          :min="0"
          :max="999999999"
          :step="0.1"
          :precision="2"
          :controls="false"
          placeholder="请输入"
          style="width: 250px"
        ></el-input-number>
      </el-form-item>
      <el-form-item label-width="135px" label="期数" prop="number">
        <el-input-number
          v-model="dialogModel.number"
          :min="0"
          :max="999999999"
          :step="0"
          :precision="0"
          :controls="false"
          placeholder="请输入"
          style="width: 250px"
        ></el-input-number>
      </el-form-item>
      <el-form-item label-width="135px" label="每期天数" prop="dayNumber">
        <el-input-number
          v-model="dialogModel.dayNumber"
          :min="0"
          :max="999999999"
          :step="0"
          :precision="0"
          :controls="false"
          placeholder="请输入"
          style="width: 250px"
        ></el-input-number>
      </el-form-item>
      <el-form-item
        label-width="135px"
        label="达标交易量(元)"
        prop="qualifiedTransactions"
      >
        <el-input-number
          v-model="dialogModel.qualifiedTransactions"
          :min="0"
          :max="999999999"
          :step="0.1"
          :precision="2"
          :controls="false"
          placeholder="请输入"
          style="width: 250px"
        ></el-input-number>
      </el-form-item>
      <el-form-item label-width="135px" label="每期奖励金(元)" prop="reward">
        <el-input-number
          v-model="dialogModel.reward"
          :min="0"
          :max="999999999"
          :step="0.1"
          :precision="2"
          :controls="false"
          placeholder="请输入"
          style="width: 250px"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="优惠券" label-width="135px">
        <el-select
          v-model="dialogModel.couponGroupId"
          placeholder="请选择"
          style="width: 250px"
        >
          <el-option
            v-for="item in couponList"
            :key="item.id"
            :label="item.groupName"
            :value="item.id"
            style="width: 250px"
          ></el-option>
        </el-select>
      </el-form-item>
    </form-dialog>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import FormDialog from "../../dialog/FormDialog";

import TransactionService from "service/TransactionService";

import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";
import activity from "service/Ainstitution";
export default {
  name: "twoapppointsnewodetojoymanage",
  components: {
    CommonTopForm,
    CommonTable,
    FormDialog,
  },
  data() {
    return {
      typeTwo: [{ tatName: "全部", id: "" }],
      typeAdd: [],
      show: false,
      formModel: {},
      tableData: [],
      submitService: TransactionService.ThreeapppointsnewodetojoymanageList,
      itemId: "",
      typeThreeList: [],
      dialogModel: {
        name: "",
        // planName: "",
        tatSimpleId: "",
        number: 0,
        agentMoney: undefined,
        qualifiedTransactions: undefined,
        reward: undefined,
        dayNumber: 0,
        couponGroupId: "",
        acqActiveMoney: "",
        saveData: "",
      },
      dialogRules: {
        name: [
          {
            required: true,
            message: "请输入",
          },
        ],
        // planName: [
        //   {
        //     required: true,
        //     message: "请输入",
        //   },
        // ],
        number: [
          {
            required: true,
            message: "请输入",
          },
        ],
        agentMoney: [
          {
            required: true,
            message: "请输入",
          },
        ],
        qualifiedTransactions: [
          {
            required: true,
            message: "请输入",
          },
        ],
        reward: [
          {
            required: true,
            message: "请输入",
          },
        ],
        dayNumber: [
          {
            required: true,
            message: "请输入",
          },
        ],
        couponGroupId: [
          {
            required: true,
            message: "请输入",
          },
        ],
        tatMoney: [
          {
            required: true,
            message: "请输入",
          },
        ],
        agentMoney1: [
          {
            required: true,
            message: "请输入",
          },
        ],
        agentMoney2: [
          {
            required: true,
            message: "请输入",
          },
        ],
        agentMoney3: [
          {
            required: true,
            message: "请输入",
          },
        ],
        acqActiveMoney: [
          {
            required: true,
            message: "请选择",
          },
        ],
        tatSimpleId: [
          {
            required: true,
            message: "请选择",
          },
        ],
      },
      isFlag: false,
      currentTypes: {},
      couponList: [],
      isPage: false,
      page: {},
    };
  },
  inject: ["reload"],
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  mounted() {
    this.load();
    this.page = this.$refs.commonTable.page;
      this.getList();
    this.getTypeNames("上游活动编号-押金", (res) => {
      this.typeThreeList = res;
    });
  },
  computed: {
    submitData() {
      console.log(this.page.pageSize,'www')
      this.params = {
        tatSimpleId: this.formModel.tatSimpleId,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };
      return this.params;
    },
    dialogData() {
      console.log(
        this.dialogModel.acqActiveMoney,
        "this.dialogModel.acqActiveMoney"
      );
      const selectedOption = this.typeThreeList.find(
        (item) => item.dictValue === this.dialogModel.acqActiveMoney
      );

      if (selectedOption) {
        this.dialogModel.saveData = selectedOption.dictKey;
      }
      const params = {
        name: this.dialogModel.name,
        // planName: this.dialogModel.planName,
        number: this.dialogModel.number,
        tatSimpleId: this.dialogModel.tatSimpleId,
        tatMoney: this.dialogModel.tatMoney,
        agentMoney1: this.dialogModel.agentMoney1,
        agentMoney2: this.dialogModel.agentMoney2,
        agentMoney3: this.dialogModel.agentMoney3,
        qualifiedTransactions: this.dialogModel.qualifiedTransactions,
        reward: this.dialogModel.reward,
        dayNumber: this.dialogModel.dayNumber,
        couponGroupId: this.dialogModel.couponGroupId,
        acqActiveMoney: this.dialogModel.acqActiveMoney,
        acqActiveCode: this.dialogModel.saveData,
      };
      if (this.itemId) {
        params.id = this.itemId;
      }
      return params;
    },
    dialogService() {
      return this.itemId
        ? TransactionService.ThreeapppointsnewodetojoymanageEdit
        : TransactionService.ThreeapppointsnewodetojoymanageAdd;
    },
    ...mapGetters(["serverType", "tatId", "userId", "textTatSimpleId"]),
  },
  watch: {},
  methods: {
    load() {
      this.formModel = {};
      this.getList();
      this.getTypeTwo();
      this.getCouponList();
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getTypeTwo() {
      this.doLoad(
        activity.signList,
        {
          size: 9999,
        },
        (res) => {
          this.doCheck(res, (res) => {
            console.log(res.contents.rows, "res1");
            res.contents.rows.forEach((item) => {
              (item.dictValue = item.id), (item.dictKey = item.tatName);
            });
            this.typeTwo = [...this.typeTwo, ...res.contents.rows];
            this.typeAdd = [...this.typeAdd, ...res.contents.rows];
            // this.tableData.forEach((item) => {
            //   console.log(this.typeTwo, "itemTwo");
            //   console.log(this.tableData, "tableData");
            //   this.typeTwo.forEach((itemTwo) => {
            //     if (item.tatSimpleId == itemTwo.dictValue) {
            //       item.tatSimpleName = itemTwo.dictKey;
            //     } else if (!item.tatSimpleId) {
            //       item.tatSimpleName = "--";
            //     }
            //   });
            // });
        
            // this.getList();
          });
        },
        "信息获取失败"
      );
    },

    getCouponList() {
      this.doLoad(
        TransactionService.coupongroupmanageList,
        {
          size: 100,
        },
        (res) => {
          this.couponList = res.contents.rows;
        },
        "信息获取失败"
      );
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    statusturns($event, scope) {
      this.doStatus($event, scope);
    },
    doStatus($event, scope) {
      this.doLoad(
        TransactionService.ThreeapppointsnewodetojoymanageStatus,
        {
          id: scope.id,
          status: $event,
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.commonSuccess(res);
          });
        },
        "操作失败"
      );
    },
    openAddDialog(item, flag) {
      this.itemId = item ? item.id : "";
      if (this.itemId) {
        this.isFlag = true;
        this.dialogModel = JSON.parse(JSON.stringify(item));
        this.dialogModel.couponGroupId = Number(this.dialogModel.couponGroupId);

        // this.dialogModel.qualifiedTransactions =
        //   this.dialogModel.qualifiedTransactions / 100;
      }
      this.$refs.formDialog.open();
    },

    dialogClose() {
      this.dialogModel = {
        name: "",
        couponGroupId: "",
        // planName: "",
        number: 0,
        tatSimpleId: "",
        tatMoney: undefined,
        agentMoney1: undefined,
        agentMoney2: undefined,
        agentMoney3: undefined,
        qualifiedTransactions: undefined,
        reward: undefined,
        dayNumber: 0,
        acqActiveMoney: undefined,
        saveData: undefined,
      };
      this.itemId = "";
    },
    dialogSuccess(res) {
      this.commonSuccess(res);
      //   this.load()
      this.$refs.formDialog.closeDialog();
    },
    commonSuccess(res) {
      this.showSuccess(res.respMsg);
      this.getList();
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result.records;
        
        console.log(this.tableData, "111");
        this.tableData.forEach((item) => {
          this.typeTwo.forEach((itemTwo) => {
            if (item.tatSimpleId == itemTwo.dictValue) {
              item.tatSimpleName = itemTwo.tatName;
            } else if (!item.tatSimpleId) {
              item.tatSimpleName = "--";
            }
          });
        });
            console.log(this.tableData,'tableData')
        this.page.currentPage = result.current;
        this.page.total = result.total;
        this.page.pageSize = result.size;
    
      });
    },
    formatterTableCoupon(row, column, cellValue, index) {
      let value = "--";
      this.couponList.forEach((item) => {
        if (item.id == cellValue) {
          value = item.groupName;
        }
      });

      return value;
    },
  },
};
</script>

<style scoped>
.button {
  width: 50px;
  padding: 11px 10px;
  margin-left: 49px;
  display: block;
  float: left;
}

.text {
  width: 145px !important;
  margin-left: 12px;
  float: left;
}

.mem-name p {
  margin-bottom: 20px;
  vertical-align: middle;
  line-height: 40px;
  color: rgba(170, 170, 170, 1);
}

.mem-name p:first-child {
  display: inline-block;
  width: 90px;
  text-align: right;
  vertical-align: middle;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
}

.chenk {
  width: 60px;
  position: relative;
  top: -61px;
  left: 189px;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar {
  width: 100px;
  height: 100px;
  display: block;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}

.iconUrl {
  width: 50px;
  height: 50px;
  margin: auto;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/view/page/AppManager/ThreeAppPointsNewOdeToJoyManage.vue